const capabilityAreas = [
  {
    id: "strategy-alignment",
    label: "Strategy & Alignment",
    description:
      "Connecting business strategy, customer insight, and cross-functional stakeholders around a shared direction before delivery begins.",
    evidence: [
      "Partnered with executives, Product, Engineering, Marketing, Customer Support, and QA to align business priorities with customer needs.",
      "Led UX strategy for major product initiatives including XE Money Transfer, balancing customer experience with commercial objectives.",
      "Established research-driven decision making using analytics, usability testing, and customer interviews to reduce uncertainty before delivery.",
      "Helped organizations move from feature-driven delivery toward customer-centred product strategy.",
    ],
  },
  {
    id: "product-platform-design",
    label: "Product & Platform Design",
    description:
      "Leading the design of enterprise platforms and global consumer products that balance customer needs, business goals, and technical realities.",
    evidence: [
      "Led UX and Product Design for XE's web platform serving more than 3 million daily users.",
      "Directed the evolution of the XE Currency app, contributing to more than 80 million installs across iOS and Android.",
      "Led major redesigns spanning responsive web, enterprise platforms, client portals, mobile products, and customer journeys.",
      "Balanced user experience, technical constraints, accessibility, and commercial objectives across complex product ecosystems.",
    ],
  },
  {
    id: "design-systems-accessibility",
    label: "Design Systems & Accessibility",
    description:
      "Creating scalable design systems, accessibility programs, governance, and shared standards that improve quality, consistency, and delivery across teams.",
    evidence: [
      "Designed a scalable design system architecture that unified multiple brands following acquisitions while supporting localization, accessibility, governance, and consistent delivery across global markets.",
      "Led the creation of Oak, Co-operators' $2m design system, unifying design and development across React, Vue, and Angular while introducing governance, release management, contribution models, and digital brand standards.",
      "Established XE's Accessibility Centre of Excellence, embedding inclusive design into design, engineering, and QA workflows rather than treating accessibility as a compliance exercise.",
      "Built design systems as organizational capabilities that improved consistency, accelerated delivery, and enabled teams to scale confidently.",
    ],
  },
  {
    id: "research-insights",
    label: "Research & Insights",
    description:
      "Building research capability, customer insight, analytics, and evidence-based decision making that reduces uncertainty and strengthens product strategy.",
    evidence: [
      "Established XE's global customer research capability, including a panel of approximately 3,000 participants supporting ongoing research and beta programs.",
      "Combined analytics, usability testing, interviews, surveys, and behavioural data to guide product direction and prioritization.",
      "Introduced research as a continuous organizational capability rather than isolated project-based studies.",
      "Helped teams make more confident product decisions by grounding strategy in customer evidence.",
    ],
  },
  {
    id: "teams-organizational-capability",
    label: "Teams & Organizational Capability",
    description:
      "Growing high-performing teams and establishing ways of working that strengthen organizations long after individual initiatives are complete.",
    evidence: [
      "Built and led multidisciplinary UX teams across enterprise and consumer organizations, supporting designers, researchers, and accessibility specialists.",
      "Established governance, shared practices, documentation, release management, and operating models that enabled teams to scale consistently.",
      "Mentored designers into broader leadership roles while fostering cross-functional collaboration and ownership.",
      "Created organizational capabilities that continued supporting delivery, quality, and continuous improvement beyond individual initiatives.",
    ],
  },
];

export default capabilityAreas;
